
import { useState, useRef, useCallback, useMemo } from "react";

// ── DATA (Same as before) ───────────────────────────────────────────────────
const TABS_DATA = [
  {
    key: "exterior",
    label: "EXTERIOR",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" style={{ width: 18, height: 18 }}>
        <path d="M5 17H3a2 2 0 01-2-2v-4l3-6h14l3 6v4a2 2 0 01-2 2h-2" />
        <circle cx="7.5" cy="17.5" r="1.5" />
        <circle cx="16.5" cy="17.5" r="1.5" />
      </svg>
    ),
    slides: [
      { label: "", img: "https://mgmotor.scene7.com/is/image/mgmotor/categoryshowcaseexterior-img-001?fmt=webp-alpha&wid=1200&qlt=85" },
      { label: "", img: "https://mgmotor.scene7.com/is/image/mgmotor/categoryshowcaseexterior-img-002?fmt=webp-alpha&wid=1200&qlt=85" },
      { label: "", img: "https://mgmotor.scene7.com/is/image/mgmotor/categoryshowcaseexterior-img-003?fmt=webp-alpha&wid=1200&qlt=85" },
      { label: "", img: "https://mgmotor.scene7.com/is/image/mgmotor/categoryshowcaseexterior-img-004?fmt=webp-alpha&wid=1200&qlt=85" },
      { label: "", img: "https://mgmotor.scene7.com/is/image/mgmotor/categoryshowcaseexterior-img-005?fmt=webp-alpha&wid=1200&qlt=85" },
    ],
  },
  {
    key: "safety",
    label: "SAFETY",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" style={{ width: 18, height: 18 }}>
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      </svg>
    ),
    slides: [
      { label: "", img: "https://mgmotor.scene7.com/is/image/mgmotor/categoryshowcasesafety-img-001?fmt=webp-alpha&wid=1200&qlt=85" },
      { label: "", img: "https://mgmotor.scene7.com/is/image/mgmotor/categoryshowcasesafety-img-002?fmt=webp-alpha&wid=1200&qlt=85" },
      { label: "", img: "https://mgmotor.scene7.com/is/image/mgmotor/categoryshowcasesafety-img-003?fmt=webp-alpha&wid=1200&qlt=85" },
      { label: "", img: "https://mgmotor.scene7.com/is/image/mgmotor/categoryshowcasesafety-img-004?fmt=webp-alpha&wid=1200&qlt=85" },
      { label: "", img: "https://mgmotor.scene7.com/is/image/mgmotor/categoryshowcasesafety-img-005?fmt=webp-alpha&wid=1200&qlt=85" },
    ],
  },
  {
    key: "tech",
    label: "TECH",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" style={{ width: 18, height: 18 }}>
        <circle cx="12" cy="12" r="3" />
        <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-2 2 2 2 0 01-2-2v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83 0 2 2 0 010-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 01-2-2 2 2 0 012-2h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 010-2.83 2 2 0 012.83 0l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 012-2 2 2 0 012 2v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 0 2 2 0 010 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 012 2 2 2 0 01-2 2h-.09a1.65 1.65 0 00-1.51 1z" />
      </svg>
    ),
    slides: [
      { label: "", img: "https://mgmotor.scene7.com/is/image/mgmotor/categoryshowcasetech-img-001?fmt=webp-alpha&wid=1200&qlt=85" },
      { label: "", img: "https://mgmotor.scene7.com/is/image/mgmotor/categoryshowcasetech-img-002?fmt=webp-alpha&wid=1200&qlt=85" },
      { label: "", img: "https://mgmotor.scene7.com/is/image/mgmotor/categoryshowcasetech-img-003?fmt=webp-alpha&wid=1200&qlt=85" },
      { label: "", img: "https://mgmotor.scene7.com/is/image/mgmotor/categoryshowcasetech-img-004?fmt=webp-alpha&wid=1200&qlt=85" },
      { label: "", img: "https://mgmotor.scene7.com/is/image/mgmotor/categoryshowcasetech-img-005?fmt=webp-alpha&wid=1200&qlt=85" },
    ],
  },
];

// ── STYLES ─────────────────────────────────
const S = {
  wrapper: { background: "#f2f2f2", padding: "60px 0", fontFamily: "'Barlow Condensed', sans-serif", minHeight: "100vh", display: "flex", alignItems: "center" },
  section: { width: "100%", margin: "0 auto" },
  tabs: { display: "flex", justifyContent: "center", gap: 12, marginBottom: 40, flexWrap: "wrap" },
  tabBtn: (active) => ({
    display: "inline-flex", alignItems: "center", gap: 8, padding: "12px 24px",
    border: `1.5px solid ${active ? "#d0021b" : "#ccc"}`, borderRadius: 4,
    background: active ? "#d0021b" : "#fff", color: active ? "#fff" : "#222",
    fontFamily: "'Barlow Condensed', sans-serif", fontSize: 15, fontWeight: 700,
    letterSpacing: "0.08em", textTransform: "uppercase", cursor: "pointer", transition: "all 0.3s ease",
  }),
  carouselOuter: { position: "relative", width: "100%", overflow: "hidden" },
  viewport: { 
    width: "100%", 
    padding: "40px 0", // Zoom effect ke liye extra space
    display: "flex",
    justifyContent: "center"
  },
  track: (index) => ({
    display: "flex",
    // 33.33% viewport width show kar rahe hain (center main, aur do side mein)
    transform: `translateX(calc(50% - ${(index * 70) + 35}%))`, 
    transition: "transform 0.6s cubic-bezier(.4,0,.2,1)",
    width: "100%",
  }),
  // Active slide logic yahan hai
  slide: (isActive) => ({
    flex: "0 0 70%", // Slide ki width thodi kam ki taki side wali dikhen
    position: "relative",
    borderRadius: 16,
    overflow: "hidden",
    background: "#000",
    aspectRatio: "16 / 8",
    margin: "0 10px",
    transition: "all 0.6s cubic-bezier(.4,0,.2,1)",
    transform: isActive ? "scale(1.1)" : "scale(0.85)", // Zoom Effect
    opacity: isActive ? 1 : 0.4, // Side slides thodi transparent
    zIndex: isActive ? 2 : 1,
    boxShadow: isActive ? "0 20px 40px rgba(0,0,0,0.2)" : "none",
  }),
  slideImg: { width: "100%", height: "100%", objectFit: "cover" },
  caption: (isActive) => ({
    position: "absolute", bottom: 0, left: 0, right: 0,
    background: "linear-gradient(transparent, rgba(0,0,0,0.9))",
    padding: "30px 0 15px", textAlign: "center",
    opacity: isActive ? 1 : 0,
    transition: "opacity 0.4s ease",
  }),
  captionText: { fontSize: "clamp(16px, 2.5vw, 24px)", fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", color: "#fff" },
  navArrow: (side, hovered) => ({
    position: "absolute", top: "50%", [side]: "10%",
    transform: "translateY(-50%)", zIndex: 10,
    width: 50, height: 50, borderRadius: "50%", border: "none",
    background: hovered ? "#d0021b" : "rgba(255,255,255,0.8)",
    color: hovered ? "#fff" : "#000",
    cursor: "pointer", transition: "all 0.3s ease",
    display: "flex", alignItems: "center", justifyContent: "center",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)"
  }),
//   dots: { display: "flex", justifyContent: "center", gap: 10, marginTop: 40 },
//   dot: (active) => ({
//     width: active ? 24 : 8, height: 8, borderRadius: 4,
//     background: active ? "#d0021b" : "#ccc", cursor: "pointer", transition: "all 0.3s ease", border: "none"
//   }),
};

// ── COMPONENT ───────────────────────────────────────────────────────────────
export default function MGCategoryShowcase() {
  const [globalIndex, setGlobalIndex] = useState(0);
  const [hovPrev, setHovPrev] = useState(false);
  const [hovNext, setHovNext] = useState(false);

  const { allSlides, tabRanges } = useMemo(() => {
    let flat = []; let ranges = {}; let currentStart = 0;
    TABS_DATA.forEach((tab) => {
      flat = [...flat, ...tab.slides];
      ranges[tab.key] = { start: currentStart, end: currentStart + tab.slides.length - 1 };
      currentStart += tab.slides.length;
    });
    return { allSlides: flat, tabRanges: ranges };
  }, []);

  const total = allSlides.length;
  const goTo = useCallback((idx) => {
    setGlobalIndex(Math.max(0, Math.min(idx, total - 1)));
  }, [total]);

  const activeTabKey = useMemo(() => {
    return Object.keys(tabRanges).find(key => 
      globalIndex >= tabRanges[key].start && globalIndex <= tabRanges[key].end
    );
  }, [globalIndex, tabRanges]);

  return (
    <div style={S.wrapper}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@600;700&display=swap');`}</style>
      
      <div style={S.section}>
        {/* TABS */}
        <div style={S.tabs}>
          {TABS_DATA.map((tab) => (
            <button key={tab.key} style={S.tabBtn(tab.key === activeTabKey)} onClick={() => goTo(tabRanges[tab.key].start)}>
              {tab.icon} {tab.label}
            </button>
          ))}
        </div>

        {/* CAROUSEL */}
        <div style={S.carouselOuter}>
          <button 
            style={S.navArrow("left", hovPrev)} 
            onMouseEnter={() => setHovPrev(true)} onMouseLeave={() => setHovPrev(false)}
            onClick={() => goTo(globalIndex - 1)}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M15 18l-6-6 6-6"/></svg>
          </button>

          <div style={S.viewport}>
            <div style={S.track(globalIndex)}>
              {allSlides.map((slide, i) => {
                const isActive = i === globalIndex;
                return (
                  <div key={i} style={S.slide(isActive)}>
                    <img src={slide.img} alt={slide.label} style={S.slideImg} />
                    <div style={S.caption(isActive)}>
                      <span style={S.captionText}>{slide.label}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <button 
            style={S.navArrow("right", hovNext)} 
            onMouseEnter={() => setHovNext(true)} onMouseLeave={() => setHovNext(false)}
            onClick={() => goTo(globalIndex + 1)}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M9 18l6-6-6-6"/></svg>
          </button>
        </div>

        {/* DOTS */}
        {/* <div style={S.dots}>
          {allSlides.map((_, i) => (
            <button key={i} style={S.dot(i === globalIndex)} onClick={() => goTo(i)} />
          ))}
        </div> */}
      </div>
    </div>
  );
}